import { ACTIONS, day, num, usd } from "@/lib/staff";
import { Badge } from "@/components/staff/ui";

const KIND = { server: ["red", "Server"], ai: ["amber", "AI"], job: ["sky", "Background job"] };
export const KindBadge = ({ kind }) => <Badge tone={(KIND[kind] || ["neutral"])[0]}>{(KIND[kind] || [0, kind])[1]}</Badge>;

export function modelColumns(withCost) {
  const cols = [
    { key: "model", label: "Model", render: (r) => <span className="font-mono text-xs">{r.model}</span> },
    { key: "requests", label: "Requests", right: true, render: (r) => num(r.requests) },
    { key: "failed", label: "Failed", right: true, render: (r) => num(r.failed) },
    { key: "tokens", label: "Tokens (est.)", right: true, render: (r) => num(r.in_tokens + r.out_tokens) },
  ];
  return withCost ? [...cols, { key: "est_cost", label: "Estimated AI cost", right: true, render: (r) => usd(r.est_cost, 4) }] : cols;
}

export const TrackingNote = ({ since }) => (
  <p className="text-xs text-neutral-500 mt-4" data-testid="ai-tracking-note">
    {since ? `AI requests are counted from ${day(since)}. Token counts are estimated from text length when the AI service doesn't report them.` : "No AI requests have been recorded yet."}
  </p>
);

export const actionLabel = (a) => ACTIONS[a] || a;

const short = (v) => (v === null || v === undefined ? "—" : typeof v === "object" ? JSON.stringify(v) : String(v));

export function AuditChange({ a }) {
  const hasChange = (a.before !== null && a.before !== undefined) || (a.after !== null && a.after !== undefined);
  const meta = a.meta && Object.keys(a.meta).length ? a.meta : null;
  if (!hasChange && !meta) return null;
  return (
    <details className="mt-1 text-xs text-neutral-400">
      <summary className="cursor-pointer text-sky-300/90 hover:text-sky-200 select-none">Details</summary>
      <div className="mt-1.5 space-y-1 font-mono break-all">
        {hasChange && <p><span className="text-neutral-500">Before:</span> {short(a.before)}</p>}
        {hasChange && <p><span className="text-neutral-500">After:</span> {short(a.after)}</p>}
        {meta && <p><span className="text-neutral-500">Notes:</span> {short(meta)}</p>}
      </div>
    </details>
  );
}
